<template>
    <div :class="isx==1?'IPhoneSix':''">
      <van-swipe @change="onChange">
        <van-swipe-item v-for="(item,skuIndex) in DetailedData.picArr" :key="skuIndex">
          <van-image :src="item" @click="swipeImgclick" >
            <template v-slot:loading><img style="width:100%;height:100%;" src="@/assets/placeholder.png" alt=""></template>
          </van-image>
        </van-swipe-item>
        <template #indicator>
          <div class="custom-indicator">
            {{ current + 1+ '/'+ImgSwipe.length}}
          </div>
        </template>
      </van-swipe>
      <div style="width:94%;margin:0 auto;">
        <p style="padding-top:8px;">
          <span class="EleName">￥{{DetailedData.price}}</span><s class="EleOriginalPrice">￥{{DetailedData.originalPrice}}</s>
        </p>
        <div style="position:relative;">
          <p style="float:left;margin-top:2%;" v-if="DetailedData.supplierCode=='ZY'" class="ZY">自营</p>
          <p class="Name">{{DetailedData.name}}</p>
          <!-- <div style="position: absolute;right: 0;bottom: 15px;">
            <img class="isCollection" v-if="DetailedData.isCollection =='N'" @click="JoinInCollection" src="@/assets/NoCollection.png" alt="">
            <img class="isCollection" v-if="DetailedData.isCollection =='Y'" @click="CancelCollection" src="@/assets/Collection.png" alt="">
          </div> -->
        </div>
        <div style="display:flex;justify-content: flex-start;align-items:baseline;" class="Tomm">
          <div style="margin-right:20px;" v-if="DetailedData.houniaoAbroadStatus  === 1"><img class="houniaoAbroadStatus"  src="@/assets/earth.png" alt=""><span style="padding-left:5px;">海外产品</span></div>
          <div v-if="DetailedData.houniaoAbroadStatus  === 1"><img class="houniaoAbroadStatus"  src="@/assets/Sigh.png" alt=""><span style="padding-left:5px;">包税</span></div>
          <div v-if="DetailedData.subTitle">{{DetailedData.subTitle}}</div>
        </div>
      </div>
      <div class="borderTop"></div>
      <div>
        <div v-if="DetailedData.skuStockList">
          <div style="border0.5px solid #ccc; border-left:none; border-right:none;border-top:none;margin-top:1px;" class="discountPrice" v-if="DetailedData.skuStockList[0].discountPrice!==0">折扣：下单可减￥{{discountPriceBian}}元</div>
        </div>
        <div v-if="DetailedData.skuStockList">
          <div style="border:0.5px solid #ccc; border-left:none;  border-right:none;"  class="discountPrice" v-if="DetailedData.skuStockList[0].cashbackPrice!==0">返利：客户下单可返￥{{DetailedData.skuStockList[0].cashbackPrice}}元</div>
        </div>
      </div>
      <div class="borderTop"></div>
      <div>
      <van-cell :title="QuantityChoice" is-link @click="groupCell()" />
      <van-cell value="限制：特价商品不可与优惠券叠加使用" />
        <van-popup
          v-model="show"
          closeable
          safe-area-inset-bottom
          position="bottom"
          class="popupShopping"
        >
        <div class="marginTop">
          <div>
            <div v-for="(item,index) in DetailedData.skuStockList" :key="index">
              <dl class="comntDl" v-if="itemIndex==index">
                <dt v-if="item.pic">
                  <van-image :src="item.pic"></van-image>
                </dt>
                <dt v-else>
                  <van-image :src="DetailedData.picArr[0]"></van-image>
                </dt>
                <dd>
                  <p class="ellpis">{{DetailedData.name}}</p>
                  <p>
                    <span class="Font" style="color:#9B2B3A;"> 价格：￥{{item.price}}</span>
                    <s class="FontSmall" style="color:#333333;padding-left:10px;">￥{{item.originalPrice}}</s>
                  </p>
                  <p style="color:#333333;">库存：{{item.stock}}</p>
                  <p style="color:#333333;">已选择：{{item.sp1}}</p>
                </dd>
              </dl>
            </div>
          </div>
          <div>
            <div class="Specifications">规格</div>
            <div style="width:75%;display:flex;flex-wrap: wrap;justify-content:flex-start">
              <van-button @click="Quantit(index)" v-for="(item,index) in DetailedData.skuStockList" style="border:0.5px solid #999999;" :key="index" :class="item.a?'colorBorder colorBorderLeft':'colorBorderLeft'" plain>{{item.sp1}}</van-button>
            </div>
            <div style="display:flex;justify-content:space-between;" class="bigSpecifi">
              <div class="SpecificationsNum">购买数量</div>
              <div style="display:flex; justify-content:center;" class="paddingTop">
                <button @click="btnSyle" style="font-size:22px;" class="btnStyle">－</button>
                <van-field v-model="digit" @blur='inputblur' type="digit" class="digit" input-align="center" />
                <button @click="btnSyleJia" :disabled="disable" style="font-size:18px;" class="btnStyle">＋</button>
              </div>
            </div>
          </div>
        </div>
        <van-button type="danger" class="dangerBlock" block @click="DefiniteChoice">确定</van-button>
        </van-popup>
      </div>
        <van-cell-group>
          <van-cell :title="Addlist" is-link @click="AddlistData($event)" />
        </van-cell-group>
        <div style="display:flex;justify-content:space-between;width:95%;margin:0 auto;padding:10px 0px ;" @click="AddlistDataList()">
            <p style="font-size:14px;">服务：</p>
            <div :class="DetailedData.supplierCode=='ZY'?'':'marbfontsizegin'">
              <div style="display:flex;justify-content:space-between;" class="service">
                <div>7天无理由退货</div>
                <div>极速退款</div>
                <div>不支持港澳台</div>
              </div>
            </div>
            <div style="display:flex;align-items:center;">
              <van-icon name="arrow" color="#A2A2A4" />
            </div>
        </div>
        <div class="borderTop"></div>
        <van-cell-group>
          <van-cell :title="UserEvaluation" :value="Eaction" is-link @click="UserEvaluationList($event)" />
        </van-cell-group>
        <div style="border-top:0.5px solid #ccc;">
          <div v-if="toastListLength.length>0">
            <dl class="VantDl">
              <dt style="float:left;" v-if="toastList.memberIcon"><van-image class="Vanimage" width="100" height="100" :src="toastList.memberIcon"/></dt>
              <dt style="float:left;" v-else><van-image class="Vanimage" width="100" height="100" :src="require('@/assets/borderImg.png')"/></dt>
              <dd class="VanDD">
                <div style="margin-right:10px;" :class="toastList.memberNickName?'memberNickNamefz':'memberNickName'">
                  <template v-if="toastList.memberNickName">
                    {{parseStringToStar(toastList.memberNickName)}}
                  </template>
                  <template v-else>****</template>
                </div>
                <van-rate v-model="Ratevalue" readonly  />
              </dd>
            </dl>
            <div class="marginL">
              <div style="color:#999999;margin-top:3px;">{{toastList.createTime}} <span style="padding-left:10px;">{{toastList.productAttribute}}</span></div>
              <div style="margin-top:3px;">{{toastList.content}}</div>
              <div v-if="toastList.pics!=''" style="display:flex;justify-content: flex-start;" >
                  <div v-for="(ele,i) in picArrs(toastList.pics)" :key="i" >
                      <van-image class="VanimageS" :src="ele" v-if="ele!=''" />
                  </div>
              </div>
            </div>
          </div>
          <div v-else style="display:flex;justify-content:center;align-items: center;" class="xiangQing">
            恭候多时，欢迎你坐第一个沙发哦~
          </div>
        </div>
        <div style="display:flex;justify-content:center;align-items: center;border-top:0.5px solid #ccc;margin-top:10px;" class="xiangQing">商品详情</div>
        <div style="width:100%;" v-html="DetailedData.detailHtml" class="ImgHtml">
          {{DetailedData.detailHtml}}
        </div>
        <van-popup
          safe-area-inset-bottom
          v-model="showThree"
          closeable
          position="bottom"
        >
        <div style="text-align: center;font-size:18px;padding-top:10px;font-weight: 800;">服务</div>
        <div style="width:96%;margin:20px auto;">
          <h4 style="display:flex;align-items:center;">48小时极速退款</h4>
          <p class="CorFont" style="color:#999999;line-height: 21px;">收到退货包裹并确认无误后，将在48小时内办理退款，退款将原路返回，不同银行处理时间不同，预计1-5个工作日到账。</p>
          <!-- <h4 style="display:flex;align-items:center;">满88元免邮费</h4>
          <p class="CorFont" style="color:#999999;line-height: 21px;"> 单笔订单金额（不含运费），大陆地区满88元包邮，不满88元收取10元邮费；跨境商品运费以下单提示页为准。 </p> -->
          <h4 style="display:flex;align-items:center;">支持7天无忧退换货</h4>
          <p class="CorFont" style="color:#999999;line-height: 21px;"> 支持7天无忧退换货。</p>
          <h4 style="display:flex;align-items:center;">以下地区暂时无法配送</h4>
          <p class="CorFont" style="color:#999999;line-height: 21px;"> 港澳台及海外地区暂时无法配送。</p>
        </div>
        </van-popup>
        <van-popup
        safe-area-inset-bottom
          v-model="showOne"
          closeable
          position="bottom"
        >
        <p class="peisong">配送至</p>
        <div class="marginTopOne">
            <van-address-list v-if="list.length>0" v-model="chosenAddressId" :list="list" default-tag-text="默认" @click-item="onClick" @edit="onEdit" @add="onAdd" isDefault />
            <div v-else >
              <p style="display:flex;justify-content:center;align-items:center;margin-top:30px;">快去添加收货地址吧~</p>
              <div style="margin-top: 20vh">
                <van-button  type="danger" class="dangerBlock" block @click="onAdd">新增地址</van-button>
                <div style="margin-bottom:4vh;"></div>
              </div>
            </div>
        </div>
        </van-popup>
        <van-goods-action safe-area-inset-bottom :class="isx==1?'isxbottom':''">
          <!-- <div class="Icon" @click="Shopping" style="border-right:none;"><p class="QuantityCircle" v-if="code>0">{{code}}</p><img src="@/assets/Shopping.png" alt=""></div> -->
          <!-- <p class="Icon" @click="Customer" style="border-right:none;"><img src="@/assets/Customer.png" alt=""></p> -->
          <!-- <p class="Icon" @click="shareclick()"><img src="@/assets/share.png" alt=""></p> -->
          <div v-if="DetailedData.status==1" >
            <div style="display:flex;justify-content:flex-start;" v-if="sellOut">
              <button class="btnWidth" style="border-left:none;border-right:none;" @click="remind">到货提醒</button>
              <button class="btnWidth" style="background:#DADADA;color:white;">售罄</button>
            </div>
            <div style="display:flex;justify-content:flex-start;" v-else>
              <button class="btnWidth" @click="ImmediatePurchase" style="border-left:none;border-right:none;">立即购买</button>
              <button class="btnWidth" @click="addToCart" style="background:#B4272D;color:white;">加入购物车</button>
            </div>
          </div>
          <div v-else-if="DetailedData.status==0">
            <button class="btnWidthOne" style="background:#DADADA;color:white;">售罄下架</button>
          </div>
        </van-goods-action>
        <van-dialog v-model="dialogShow" title="到货提醒" show-cancel-button @confirm="confirma">
          <p class="dialogTop">请留意该手机号码的短信，商品补货将会通知您</p>
          <p class="dialogTop">{{phone}}</p>
        </van-dialog>
    </div>
</template>
<script>
// import Qs from 'qs'
import { Swipe, SwipeItem, Image, Popup, Cell, CellGroup, Button, GoodsAction, Stepper, Field, Dialog, AddressList, Icon, Rate, ImagePreview, Toast } from 'vant'
import { productInfo, address, addcartItem, memberinfo, arrivalReminder, comment } from '../../request/api.js'
// import { kInputFromiOS } from '../../components/interactive'
export default {
  components: {
    [Image.name]: Image,
    [SwipeItem.name]: SwipeItem,
    [Swipe.name]: Swipe,
    [Popup.name]: Popup,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Button.name]: Button,
    [GoodsAction.name]: GoodsAction,
    [Stepper.name]: Stepper,
    [Field.name]: Field,
    [AddressList.name]: AddressList,
    [Icon.name]: Icon,
    [Rate.name]: Rate,
    [ImagePreview.name]: ImagePreview,
    [Toast.name]: Toast,
    [Dialog.Component.name]: Dialog.Component
  },
  watch: {
    sp1 (newName, oldName) {
      console.log(newName)
      if (newName) {
        console.log('数据改变了')
        this.$set(this.DetailedData.skuStockList[0], 'a', false)
        this.$set(this.DetailedData.skuStockList[this.itemIndex], 'a', true)
      }
    },
    digit (newName, oldName) {
      console.log(newName, oldName)
      console.log(this.stock)
      if (newName > this.stock) {
        this.disable = true
        this.digit = this.stock
        Dialog.alert({
          message: '小主，库存不够了哦'
        }).then(() => {
          // on close
        })
      } else {
        this.disable = false
        this.digit = this.digit.replace(/^[0]+[0-9]*$/gi, '')
      }
    },
    deep: true,
    immediate: true
  },
  data () {
    return {
      id: '',
      current: 0,
      ImgSwipe: [],
      DetailedData: {},
      show: false,
      showOne: false,
      showThree: false,
      QuantityChoice: '数量规格选择',
      Addlist: '配送：选择配送地址',
      itemIndex: 0,
      stock: '',
      digit: 1,
      sp1: '',
      addShow: false,
      disable: false,
      chosenAddressId: '',
      list: [],
      UserEvaluation: '',
      Eaction: '',
      Ratevalue: 5,
      toastList: [],
      toastListLength: [],
      AddressID: '',
      sp1id: '',
      options: 1,
      code: 0,
      sellOut: false,
      phone: 0,
      dialogShow: false,
      gobreak: 1,
      discountPriceBian: '', // 折扣价格
      isx: 0
    }
  },
  methods: {
    // 轮播图
    onChange (index) {
      this.current = index
    },
    // 点击数量规格选择
    groupCell () {
      this.options = 2
      this.show = true
      // this.DetailedData.skuStockList.map(item => {
      //   console.log(item.a)
      //   this.$set(item, 'a', false)
      // })
      if (this.QuantityChoice === '数量规格选择') {
        this.$set(this.DetailedData.skuStockList[0], 'a', true)
        this.sp1 = this.DetailedData.skuStockList[0].sp1
        this.stock = this.DetailedData.skuStockList[0].stock
        this.discountPriceBian = this.DetailedData.skuStockList[0].discountPrice
      }
    },
    //
    inputblur() {
      if (this.digit <= 0) {
        this.digit = 1
      }
    },
    parseStringToStar (str) {
      console.log(str)
      return str.length > 1 ? str.substr(0, 1) + new Array(str.length - 1).join('*') + str.substr(-1) : str
    },
    // 选择商品规格
    Quantit (i) {
      this.itemIndex = i
      this.DetailedData.skuStockList.map(item => {
        this.$set(item, 'a', false)
        console.log(item)
      })
      this.$set(this.DetailedData.skuStockList[i], 'a', true)
      this.stock = this.DetailedData.skuStockList[i].stock
      this.sp1 = this.DetailedData.skuStockList[i].sp1
      this.sp1id = this.DetailedData.skuStockList[i].id
    },
    // 添加地址
    onAdd () {
      this.$router.push('/addressList')
    },
    // 编辑地址
    onEdit (item, index) {
      this.$router.push({ path: '/addressList', query: { DataDisplay: item.id } })
    },
    // 立即购买
    ImmediatePurchase () {
      this.DetailedData.skuStockList.map(item => {
        this.$set(item, 'a', false)
      })
      this.$set(this.DetailedData.skuStockList[0], 'a', true)
      this.sp1 = this.DetailedData.skuStockList[0].sp1
      this.stock = this.DetailedData.skuStockList[0].stock
      // 地址id
      if (this.QuantityChoice !== '数量规格选择') {
        if (this.AddressID === '') {
          if (this.list.length > 0) {
            console.log(this.AddressID)
            this.AddressID = this.list[0].id
          }
        }
        this.$router.push({ path: '/OrderPage', query: { id: this.id, AddressID: this.AddressID, sp1id: this.sp1id, number: this.digit } })
      } else {
        this.options = 1
        this.show = true
      }
    },
    // 加入购物车
    addToCart() {
      if (this.QuantityChoice === '数量规格选择') {
        this.$set(this.DetailedData.skuStockList[0], 'a', true)
        this.sp1 = this.DetailedData.skuStockList[0].sp1
        this.stock = this.DetailedData.skuStockList[0].stock
        this.discountPriceBian = this.DetailedData.skuStockList[this.itemIndex].discountPrice
      }
      if (this.QuantityChoice !== '数量规格选择') {
        addcartItem({
          productId: this.id,
          productSkuId: this.sp1id,
          quantity: this.digit
        }).then(res => {
          console.log(res)
          if (res.code === 200) {
            Toast.success('加入购物车成功')
          } else {
            Toast.fail(res.message)
          }
        }).catch(res => {
          Toast.fail(res.message)
          console.log(res)
        })
      } else {
        this.options = 3
        this.show = true
      }
    },
    remind() {
      memberinfo().then(res => {
        console.log(res)
        if (res.code === 200) {
          this.dialogShow = true
          this.phone = res.data.phone
        }
      }).catch(res => {
        console.log(res)
      })
    },
    confirma() {
      console.log(111)
      arrivalReminder({ productId: this.id }).then(res => {
        console.log(res)
      }).catch(res => {
        console.log(res)
      })
    },
    // 滚动
    // Inputfocus () {
    //   this.$nextTick(() => {
    //     var container = this.$el.querySelector('#new_message')
    //     console.log(container.scrollHeight)
    //     container.scrollTop = container.scrollHeight
    //   })
    // },
    // 配送地址选择
    onClick (item, index) {
      console.log(event)
      if (event.target.className !== 'van-icon van-icon-edit van-address-item__edit') {
        this.AddressID = item.id
        this.showOne = false
        this.Addlist = '配送：' + item.address
      }
    },
    // 确定
    DefiniteChoice () {
      this.show = false
      // if (localStorage.getItem('token') !== null) {
      if (this.options === 1) {
        // console.log(localStorage.getItem('token') !== null)
        // console.log(localStorage.getItem('token'))
        // console.log('立即购买')
        if (this.AddressID === '') {
          if (this.list.length > 0) {
            this.AddressID = this.list[0].id
          } else {
            this.AddressID = ''
          }
        }
        if (this.sp1id === '') {
          this.sp1id = this.DetailedData.skuStockList[0].id
        }
        this.QuantityChoice = '已选择：' + this.sp1 + '，' + this.digit + '件'
        // console.log(this.sp1id, '商品主键ID')
        // console.log(this.id, '商品的productId')
        // console.log(this.AddressID, '默认的地址')
        // console.log(this.digit, '商品的数量')
        this.$router.push({ path: '/OrderPage', query: { id: this.id, AddressID: this.AddressID, sp1id: this.sp1id, number: this.digit } })
        // }
        //  else {
        //   const ua = navigator.userAgent.toLowerCase()
        //   // Android终端
        //   const isAndroid = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1
        //   // Ios终端
        //   const isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
        //   console.log(isiOS, isAndroid)
        //   if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
        //     kInputFromiOS('login')
        //   } else if (/(Android)/i.test(navigator.userAgent)) {
        //     console.log('传递参数安卓')
        //     var message = {
        //       body: 'login'
        //     }
        //     var jsonStr = JSON.stringify(message)
        //     window.android.getDataFormVue(jsonStr)
        //     // Android终端
        //     // alert('Android终端')
        //     console.log('Android终端')
        //   }
        // }
      } else if (this.options === 2) {
        // console.log('选择规格')
        if (this.DetailedData.skuStockList.length === 1) {
          this.sp1id = this.DetailedData.skuStockList[0].id
          this.discountPriceBian = this.DetailedData.skuStockList[0].discountPrice
        }
        this.discountPriceBian = this.DetailedData.skuStockList[this.itemIndex].discountPrice
        this.QuantityChoice = '已选择：' + this.sp1 + '，' + this.digit + '件'
        // console.log(this.sp1id, '商品主键ID')
        // console.log(this.id, '商品的productId')
        // console.log(this.AddressID, '默认的地址')
        // console.log(this.digit, '商品的数量')
      } else if (this.options === 3) {
        // console.log('加入购物车')
        if (this.DetailedData.skuStockList.length === 1) {
          this.sp1id = this.DetailedData.skuStockList[0].id
        } else {
          if (this.sp1id === '') {
            this.sp1id = this.DetailedData.skuStockList[0].id
          }
        }
        this.QuantityChoice = '已选择：' + this.sp1 + '，' + this.digit + '件'
        addcartItem({
          productId: this.id,
          productSkuId: this.sp1id,
          quantity: this.digit
        }).then(res => {
          if (res.code === 200) {
            Toast.success('加入购物车成功')
            if (res.data === 'N') {
              this.code++
              sessionStorage.setItem('code', this.code)
            }
          } else {
            Toast.fail(res.message)
          }
          console.log(res)
        }).catch(res => {
          Toast.fail(res.message)
          console.log(res)
        })
      }
      // } else {
      //   Toast.fail('未登录')
      // }
    },
    picArrs (pics) {
      return pics.split(',')
    },
    // 收货地址
    AddlistData (i) {
      console.log(i)
      this.showOne = true
      address().then(res => {
        console.log(res)
        if (res.code === 200) {
          if (res.data.length !== 0) {
            this.list = res.data
            this.list = this.list.map((item, index) => {
              return {
                id: item.id,
                name: item.name,
                tel: item.phone,
                isDefault: item.defaultStatus,
                address: item.addrNameFull + item.detailAddress
              }
            })
          }
        }
      }).catch(res => {
        console.log(res)
      })
    },
    // 地址
    AddlistDataList () {
      this.showThree = true
    },
    /// 图片详情
    swipeImgclick () {
      ImagePreview({
        images: this.DetailedData.picArr,
        closeOnPopstate: true,
        startPosition: this.current
      })
    },
    // 商品加
    btnSyleJia () {
      console.log('加')
      this.digit++
    },
    // 商品减
    btnSyle () {
      console.log('减')
      this.digit--
      if (this.digit === 0) {
        this.digit = 1
        Dialog.alert({
          message: '小主，不能再减咯'
        }).then(() => {
          // on close
        })
      }
    },
    // 服务
    UserEvaluationList () {
      this.$router.push(`/EvaluationPage/${this.id}`)
    }
  },
  created () {
    document.documentElement.scrollTop = 0
    const ua = navigator.userAgent.toLowerCase()
    // Android终端
    const isAndroid = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1
    // Ios终端
    const isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
    console.log(isiOS, isAndroid)
    if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
      var isNewIphone = window.screen.height >= 812 && window.devicePixelRatio >= 2
      if (isNewIphone) {
        this.isx = 1
      } else {
        this.isx = 2
      }
      // Ios
      // alert('Ios')
    } else if (/(Android)/i.test(navigator.userAgent)) {
      console.log('Android终端')
      this.isx = 3
    }
    this.code = sessionStorage.getItem('code')
    this.gobreak = sessionStorage.getItem('gobreak')
    console.log(this.$route.query.id, 'this.$route.query.id')
    this.id = this.$route.query.id
    console.log(this.$route.query.id)
    // const params = {
    //   id: this.id
    // }
    productInfo(this.id, this.$route.query.skuId).then(res => {
      console.log(res, 'res')
      this.DetailedData = res.data
      this.ImgSwipe = res.data.picArr
      this.sku = res.data.skuStockList
      this.discountPriceBian = res.data.skuStockList[0].discountPrice
      var a = 0
      this.sku.map(item => {
        if (item.stock === 0) {
          a++
        }
      })
      if (this.sku.length === a) {
        this.sellOut = true
      }
      // if (localStorage.getItem('token') !== null) {
      return this.DetailedData
      // }
    }).then(res => {
      console.log(res)
      // if (localStorage.getItem('token') !== null) {
      const params = {
        pageSize: 1,
        pageNum: 1,
        id: this.id
      }
      comment(params).then(res => {
        console.log(res)
        this.UserEvaluation = '用户评论' + '(' + this.DetailedData.comment + ')'
        this.Eaction = this.DetailedData.commentRate + '%  ' + '好评'
        this.toastListLength = res.data.list
        if (this.toastListLength.length > 0) {
          this.toastList = res.data.list[0]
          this.Ratevalue = res.data.list[0].star
        }
      }).catch(res => {
        console.log(res)
      })
      // }
    }).catch(res => {
      console.log(res)
    })
    // console.log((localStorage.getItem('token') === null))
    // console.log((localStorage.getItem('token')))
    if (localStorage.getItem('token') === null) {
      console.log('本地没有token')
    } else {
      address().then(res => {
        this.Addlist = '配送：' + res.data[0].addrNameFull + res.data[0].detailAddress
        this.chosenAddressId = res.data[0].id
        console.log(this.chosenAddressId)
        if (res.code === 200) {
          if (res.data.length !== 0) {
            this.list = res.data
            this.list = this.list.map((item, index) => {
              return {
                id: item.id,
                name: item.name,
                tel: item.phone,
                isDefault: item.defaultStatus,
                address: item.addrNameFull + item.detailAddress
              }
            })
          }
        }
      }).catch(res => {
        console.log(res)
      })
    }
  },
  Destroy() {
    ImagePreview({ closeOnPopstate: true })
  },
  beforeRouteEnter (to, from, next) {
    console.log(to, from)
    if (from.path === '/index') {
      sessionStorage.setItem('gobreak', 1)
    } else {
      sessionStorage.setItem('gobreak', 2)
    }
    next()
    console.log(sessionStorage.getItem('gobreak'))
  }
}
</script>
<style lang="less" scoped>
.popupShopping /deep/ .van-button--danger{
  margin-bottom: 40px;
}
.isxbottom{
    position: fixed;
    right: 0;
    bottom: 0px;
    left: 0;
    padding-bottom: 40px;
}
.QuantityCircle{
  width: 35px;
  height: 35px;
  border-radius: 50%;
  background-color: #B4272D;
  position: absolute;
  left: 55px;
  top: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}
  .IPhoneSix {
      height: 1624px;
      width: 100%;
    }
    .van-swipe{
      height: 750px;
      width: 750px;
    }
  .custom-indicator {
      position: absolute;
      right: 20px;
      bottom: 5px;
      padding: 2px 5px;
      font-size: 26px;
      background: rgba(255, 255, 255, 0.1);
      color: #cccccc;
    }
    .van-image img{
      width: 100%;
      height: 100%;
    }
    .EleName {
      color: #333333;
      font-size: 40px;
      font-weight:bold;
      padding-right: 15px;
    }
    .EleOriginalPrice {
      color: #999999;
      font-size: 24px;
    }
    .Name{
      line-height: 60px;
      font-size: 32px;
      overflow : hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      padding-bottom: 10px;
      padding-left: 10px;
      width: 542px;
      color: #333333;
    }
    .isCollection{
      width: 40px;
      height: 38px;
    }
    .borderTop{
      height: 24px;background-color:#F2F2F2;
    }
    .discountPrice{
      display: flex;
      align-items:center;
      font-size: 28px;
      color:rgba(51,51,51,1);
      height: 100px;
      padding-left: 3%;
    }
    /deep/.van-popup__close-icon{
      font-size: 40px;
    }
    /deep/.van-image{
      width: 100%;
      height: 100%;
    }
    .houniaoAbroadStatus{
      width: 23px;
      height: 23px;
    }
    .Tomm{
      padding-bottom: 25px;
      font-size: 28px;
      color: #666666;
    }
    /deep/ .van-cell{
      line-height: 83px;
      font-size: 28px;
    }
    .van-cell__left-icon, .van-cell__right-icon {
      line-height: 83px;
    }
    .marginTop{
      margin-top: 20px;
      width: 94%;
      margin: 45px auto;
    }
    .marginTopOne{
      width: 96%;
      margin: 0 auto;
      overflow: auto;
    }
    .colorBorder{
      color: #B4272D;
      border: 0.5px solid #B4272D !important;/*no*/
    }
    /deep/ .van-address-item{
      border-bottom: 1px solid #333333;/*no*/
    }
    /deep/ .colorBorderLeft {
      margin-right: 35px;
      font-size: 24px;
      margin-top: 20px;
      overflow : hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
    }
    .peisong{
      margin-top: 30px;
      margin-left: 32px;
      padding-bottom: 20px;
      margin-right: 30px;
      border-radius: 8px;
      border-bottom: 1px solid #333333;/*no*/
      font-size: 26px;
    }
    /deep/ .van-popup__close-icon--top-right {
      top: 30px !important;
    }
    .marginL{
      margin-left: 10px;
    }
    .comntDl {
      height: 180px;
      display: flex;
      justify-content: flex-start;
      dt{
        width: 180px;
        height:180px;
        .van-image{
          width: 100%;
          height: 100%;
        }
      }
      dd{
        font-size: 28px;
        margin-left: 20px;
        p{
          line-height: 48px;
        }
      }
    }
    .VantDl {
      height: 64px;
      margin: 12px;
    }
    .Vanimage {
      width: 64px !important;
      height: 64px !important;
    }
    .VanDD {
      height: 64px;
      display: flex;
      align-items: center;
      margin-left: 80px;
    }
    .Specifications{
      line-height: 60px;
      font-size: 28px;
    }
    .SpecificationsNum {
      line-height: 85px;
      font-size: 28px;
      width: 140px;
    }
    .van-goods-action{
      height: 100px;
    }
    .van-radio-group{
      padding-bottom: 50px;
    }
    .btnWidth{
      width: 375px;
      height:100px;
      background-color: #fff;
      border: 1px solid #ccc;
      font-size: 28px;
    }
    .btnWidthOne{
      width: 750px;
      height:100px;
      background:rgba(218,218,218,1);
      background-color: #fff;
      border: 1px solid #ccc;
      font-size: 28px;
    }
    /deep/ .van-radio__icon {
      padding-top: 10px;
    }
    /deep/ .van-address-item__address{
      padding-top: 10px;
      font-size: 26px;
      height: 26px;
      line-height: 26px;
      overflow : hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
    }
    .Icon{
      width: 98px;
      height: 100%;
      border: 1px solid #ccc;
      display: flex;
      justify-content: center;
      align-items: center;
      img{
        width: 50px;
        height: 45px;
      }
    }
    /deep/ .colorBorderLeft {
      height: 68px;
      border-radius: 4px;
    }
    /deep/.van-stepper__input{
      width: 129px;
      height: 63px;
    }
    /deep/ .van-stepper__plus {
      width: 93px;
      height: 63px;
      color: black;
      font-weight:bold;
    }
    /deep/ .van-stepper__minus {
      width: 93px;
      height: 63px;
      color: black;
      font-weight:bold;
    }
    /deep/.van-stepper__minus::after, .van-stepper__plus::after {
      width: 60px;
      height: 50px;
    }
    //多行文本溢出隐藏
    .ellpis{
      overflow : hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
    }
    .Font {
      font-size: 28px;
    }
    .FontSmall{
      font-size: 27px;
    }
    //ios 输入框向下偏移
    /deep/.van-field__control {
      border: 1px solid #666666;/*no*/
      height: 64px;
      border-radius: 3px;/*no*/
      padding-bottom: 6px;
    }
    .btnStyle{
      width: 93px;
      height: 63px;
      display: flex;
      justify-content: center;
      align-items: baseline ;
      background-color: #fff;
      border-radius: 3px;/*no*/
      border: 1px solid #666666;/*no*/
    }
    /deep/ .van-field{
      padding: 0;
      width: 129px;
      height: 64px;
      margin: 0 15px;/*no*/
    }
    .digit /deep/ .van-field__body input {
      line-height: normal;
    }
    .bigSpecifi {
      margin-top: 25px;
    }
    .paddingTop{
      padding-top: 13px;
    }
    /deep/ .van-button--danger{
      background-color:#B4272D;
      height: 80px;
    }
    /deep/ .dangerBlock {
      font-size: 30px;
    }
    /deep/ .van-toast__text{
      width: 100px;
    }
    .CorFont{
      font-size: 28px;
    }
    .ImgHtml{
      margin-bottom: 100px;
    }
    .ImgHtml /deep/ img{
      width: 100%;
      height: 100%;
      margin-top: -3px;
    }
    .xiangQing {
      height: 100px;
      font-size: 26px;
    }
    .ZY{
      color: white;
      padding:2px 12px;
      font-size: 24px;
      border-radius: 5px;
      background-color: #E33F36;
  }
  .van-swipe-item {
    width: 375px;
  }
  .bfontsize{
    font-size: 80px;
    line-height: 10px;
  }
  h4{
    font-size: 28px;
  }
  /deep/ .van-address-item__name {
    font-size: 25px;
    height: 36px;
  }
  /deep/ .van-tag {
    font-size: 25px;
  }
  /deep/ .van-address-item__edit{
    font-size: 36px;
  }
  /deep/ .van-cell__title {
    overflow : hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
  }
  /deep/ .van-dialog{
    width: 520px !important;
    height: 300px !important;
    font-size:32px;
  }
  .dialogTop:nth-child(1){
    height: 70px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 22px;
    color: #999999;
  }
  .dialogTop:nth-child(2){
    height: 70px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 32px;
    color: #999999;
    margin: 0px 50px;
    border-radius: 20px;
    border: 1px solid #999999;/*no*/
  }
  /deep/ .van-button--large {
    height: 80px !important;
    padding-top: 25px;
  }
  .VanimageS {
        width: 100px;
        height: 100px;
        /deep/.van-image__error{
        width: 100px;
          height: 100px;
        img{
            width: 100%;
            height: 100%;
          }
      }
    }
    .memberNickName{
      padding-top: 13px;
      font-size: 24px;
    }
    .memberNickNamefz{
      font-size: 24px;
    }
    .marbfontsizegin{
      margin-right: 200px;
    }
    .service{
      width: 500px;
      line-height: 38px;
      font-size: 24px;
    }
</style>
